import { render, staticRenderFns } from "./DeletePaymentMethodErrorModal.vue?vue&type=template&id=0bbe4838&scoped=true&"
import script from "./DeletePaymentMethodErrorModal.vue?vue&type=script&lang=ts&"
export * from "./DeletePaymentMethodErrorModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeletePaymentMethodErrorModal.vue?vue&type=style&index=0&id=0bbe4838&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe4838",
  null
  
)

export default component.exports